const getInitials = (name: string) => {
  const nameParts = name.split(" ");
  const initials = nameParts.map((part: string) => part[0]).join("");

  return initials;
};

export default getInitials;
